import React, { useState, useTransition, useEffect, useNavigate } from "react";
import { Row, Col, Collapse, Button } from "react-bootstrap";
import { Link, NavLink, useParams, useLocation } from "react-router-dom";
import colombinaLogo from "../../assets/LOGO_COLOMBINA.png";
import colombinaLogoENG from "../../assets/home/LOGO_COL_ENG.png";

import homeButton from "../../assets/home/BOTON-INICIO-.png";
import market from "../../assets/LOGO_MARKET_COLOMBINA.png";
import esp from "../../assets/esp.png";
import eng from "../../assets/eng.png";
import esp_yellow from "../../assets/esp_yellow.png";
import eng_yellow from "../../assets/eng_yellow.png";
import BARA_VERTICAL from "../../assets/BARA_VERTICAL.png";
import { MdVolumeUp } from "react-icons/md";
import marketLogo from "../../assets/home/MARKET-COLOMBINA.png";
import { MdVolumeOff } from "react-icons/md";
import { FormattedMessage } from "react-intl";
import { LOCALES } from "../../i8n/locales";
import backgroundMusic from "../../assets/music/jingle.mp3";
import RappiLogo from "../../assets/2024/navbar/BOTON-MENU-RAPPI.png";

export const NavBar = ({ setLanguage, lang, playingPar, setPlayingPar }) => {
  const useAudio = (url) => {
    const [audio] = useState(new Audio(url));

    const toggle = () => setPlayingPar(!playingPar);

    useEffect(() => {
      playingPar ? audio.play() : audio.pause();
      playingPar ? (audio.loop = true) : audio.pause();
    }, [playingPar]);

    useEffect(() => {
      audio.addEventListener("ended", () => setPlayingPar(true));
      return () => {
        audio.removeEventListener("ended", () => setPlayingPar(true));
      };
    }, []);

    return [playingPar, toggle];
  };

  let activeStyle = {
    color: "orange",
  };

  const [open, setOpen] = useState(false);

  const location = useLocation();

  const soundUrl = "../../assets/music/jingle.mp3";

  const [playing, toggle] = useAudio(backgroundMusic);

  const { pais } = useParams();

  const paises = [
    "BOLIVIA",
    "ECUADOR",
    "PERU",
    "VENEZUELA",
    "COLOMBIA",
    "COSTA_RICA",
    "SALVADOR",
    "GUATEMALA",
    "HONDURAS",
    "PANAMA",
    "GUYANAS",
    "JAMAICA",
    "SURINAM",
    "TRINIDAD_TOBAGO",
    "REPUBLICA_DOMINICANA",
    "PUERTO_RICO",
    "USA",
  ];

  //console.log(paises.includes(pais) ? "estoy en los paises" : "noestoy");

  const path = useLocation().pathname;
  const donde = path.split("/")[1];
  // console.log(donde)
  return (
    <div>
      <Row
        className="navbar align-items-center"
        id={
          path.includes("fun") || path.includes("recipes") ? "transparent" : ""
        }
      >
        <Col xs={2} className="text-left navbar__col">
          <Link to={"/" + donde}>
            <img
              alt="logo"
              style={{ width: "140px" }}
              src={lang.includes("es") ? colombinaLogo : colombinaLogoENG}
            ></img>
          </Link>
        </Col>

        <Col
          xs={4}
          className="text-left navbar__col d-flex justify-content-center align-items-center navbar__gap"
        >
          <Link to={"/"}>
            <img
              alt="home"
              style={{ width: "140px" }}
              src={lang.includes("es") ? homeButton : homeButton}
            ></img>
          </Link>
          <span>
            {" "}
            <img
              src={BARA_VERTICAL}
              alt="market"
              width="2rem"
              height="30px"
            ></img>{" "}
          </span>
          <button
            className="botonIdiomas"
            onClick={() => {
              setLanguage(LOCALES.ENGLISH);
            }}
          >
            <img
              src={lang === LOCALES.ENGLISH ? eng_yellow : eng}
              alt="market"
              width="140px"
              height="auto"
            ></img>
          </button>
          <span>
            {" "}
            <img
              src={BARA_VERTICAL}
              alt="market"
              width="2rem"
              height="30px"
            ></img>{" "}
          </span>
          <button
            className="botonIdiomas"
            onClick={() => {
              setLanguage(LOCALES.SPANISH);
            }}
          >
            <img
              src={lang === LOCALES.ENGLISH ? esp : esp_yellow}
              alt="market"
              width="140px"
              height="auto"
            ></img>
          </button>
        </Col>
        {/* <FormattedMessage id="lan" /> */}

        <Col
          xs={4}
          l
          className="text-center navbar__col d-flex justify-content-center align-items-center navbar__gap"
        >
          <Link to="/">
            <img
              src={RappiLogo}
              alt="market"
              width="40px"
              height="40px"
              style={{ marginLeft: "10px" }}
            ></img>
          </Link>
          <span>
            {" "}
            <img
              src={BARA_VERTICAL}
              alt="market"
              width="2rem"
              height="30px"
            ></img>{" "}
          </span>

          {donde ? (
            <Link to="/">
              <img
                src={
                  paises.includes(donde)
                    ? require("../../assets/" + donde + ".png")
                    : require("../../assets/COLOMBIA.png")
                }
                alt="market"
                width="40px"
                height="40px"
                style={{ marginLeft: "10px" }}
              ></img>
            </Link>
          ) : (
            <></>
          )}

          <Button className="botonIdiomas"></Button>

          <button
            className="botonSonido"
            onClick={toggle}
            style={{ padding: 0 }}
          >
            {playing ? <MdVolumeUp /> : <MdVolumeOff />}
          </button>
        </Col>
      </Row>
      <Row className="navbar__responsive">
        <Row className="rowArriba">
          <Col
            xs={2}
            className="text-left navbar__col__toggle navbar__responsive__col"
            id="margenArriba"
          >
            <button
              className="navbar-toggler"
              type="button"
              onClick={() => setOpen(!open)}
              aria-controls="navbarCollapse"
              aria-expanded={open}
            >
              <span className="navbar-toggler-icon"></span>
            </button>
          </Col>
          <Col
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Link to={"/" + donde} style={{ width: "fit-content" }}>
              <img
                style={{ width: "80px" }}
                src={lang.includes("es") ? colombinaLogo : colombinaLogoENG}
              ></img>
            </Link>
          </Col>
          <Col
            xs={2}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <button
              className="botonSonido"
              onClick={toggle}
              style={{ padding: 0 }}
            >
              {playing ? <MdVolumeUp /> : <MdVolumeOff />}
            </button>
          </Col>
          <Col
            xs={2}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {donde ? (
              <Link to="/">
                <img
                  src={
                    paises.includes(donde)
                      ? require("../../assets/" + donde + ".png")
                      : require("../../assets/COLOMBIA.png")
                  }
                  alt="market"
                  width="40px"
                  height="40px"
                  style={{ marginLeft: "10px" }}
                ></img>
              </Link>
            ) : (
              <></>
            )}
          </Col>
        </Row>

        <Collapse in={open}>
          <div id="navbarCollapse">
            <Row>
              <Col
                xs={12}
                lg={1}
                className="text-center navbar__col"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <button
                  className="botonIdiomas"
                  onClick={() => {
                    setLanguage(LOCALES.ENGLISH);
                  }}
                >
                  <img
                    src={lang === LOCALES.ENGLISH ? eng_yellow : eng}
                    alt="market"
                    width="70px"
                    height="20px"
                  ></img>
                </button>
                <span>
                  <img
                    src={BARA_VERTICAL}
                    alt="market"
                    width="auto"
                    height="30px"
                  ></img>
                </span>
                <button
                  className="botonIdiomas"
                  onClick={() => {
                    setLanguage(LOCALES.SPANISH);
                  }}
                >
                  <img
                    src={lang === LOCALES.ENGLISH ? esp : esp_yellow}
                    alt="market"
                    width="70px"
                    height="20px"
                  ></img>
                </button>
              </Col>
            </Row>

            {donde === "COLOMBIA" ? (
              <Row>
                <a
                  href="https://marketcolombina.com"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={market}
                    alt="market"
                    width="80px"
                    height="45px"
                    margin-left="20px"
                  ></img>
                </a>
              </Row>
            ) : (
              <></>
            )}
          </div>
        </Collapse>
      </Row>
    </div>
  );
};
